import React from "react";
import { Box, Typography } from "@mui/material";
import { colors } from "../../../styles/colors";

interface MapAttributionProps {
  align?: "left" | "right";
}

const MapAttribution: React.FC<MapAttributionProps> = ({ align = "left" }) => (
  <Box
    sx={{
      position: "absolute",
      bottom: 6,
      ...(align === "left" ? { left: 8 } : { right: 8 }),
      zIndex: 1000,
      pointerEvents: "none",
    }}
  >
    <Typography
      variant="caption"
      sx={{ fontSize: "0.65rem", color: colors.text.disabled, lineHeight: 1 }}
    >
      {"© "}
      <a
        href="https://www.openstreetmap.org/copyright"
        target="_blank"
        rel="noreferrer"
        style={{ color: "inherit", pointerEvents: "auto" }}
      >
        OpenStreetMap
      </a>
      {" contributors © "}
      <a
        href="https://carto.com/attributions"
        target="_blank"
        rel="noreferrer"
        style={{ color: "inherit", pointerEvents: "auto" }}
      >
        CARTO
      </a>
    </Typography>
  </Box>
);

export default MapAttribution;
